module.exports = __webpack_public_path__ + "img/works-we-love.9760aaa.png";